var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sparkline',{attrs:{"value":_vm.value,"line-width":_vm.width,"stroke-linecap":_vm.lineCap,"type":_vm.type},scopedSlots:_vm._u([{key:"label",fn:function(item){return [_vm._v(" $"+_vm._s(item.value)+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }